export const ENTITY_TYPES = Object.freeze({
  ORGANIZATION: "organization",
  VESSEL: "vessel",
  VESSEL_PARTICULARS: "vesselParticulars",
  TANK: "tank",
  TANK_HISTORY_ENTRY: "tankHistoryEntry",
  VOYAGE: "voyage",
  TRIP: "trip",
  TRIP_CARGO: "tripCargo",
  AUDIT_ENTRY: "auditEntry",
  SYNC_OPERATION: "syncOperation",
});
